export interface PaginationSortBy {
  field: string;
  order: SortDirection;
}

export enum FilterField {
  CITY = "city",
  BEACH = "beach",
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export interface PaginationFilterBy {
  field: FilterField;
  value: any;
}

export interface PaginationOptions {
  limit: number;
  start_after?: string;
  end_before?: string;
  sort_by?: PaginationSortBy[];
  filter_by?: PaginationFilterBy[];
}
